import PanToolOutlinedIcon from '@mui/icons-material/PanToolOutlined'
import PinDropOutlinedIcon from '@mui/icons-material/PinDropOutlined'
import Tooltip from '@mui/material/Tooltip'
import React from 'react'

import { getWorkOrderStatusDisplayLabel, WORK_ORDER_STATUS } from 'settings/constants/service'
import T from 'T'
import { AUTO_COMPLETE_STATUS } from 'types/api/work-order/workOrderStatus'

const { SERVICED } = WORK_ORDER_STATUS

type Props = {
  completionStatus?: string | null
  autoComplete?: string | null
}

/**
 * How a container reached completion, not what its status is — the neighbouring
 * WorkOrderStatusBadge already draws a glyph per status, so covering anything but Serviced here
 * would double it up. Glyphs are MUI stand-ins until the design system ships the real set.
 */
const ContainerCompletionBadge: React.FC<Props> = ({ completionStatus, autoComplete }) => {
  if (getWorkOrderStatusDisplayLabel(completionStatus) !== SERVICED) return null

  // Case-insensitive because the OpenAPI schema and the @JsonValue disagree on the wire form.
  const isAutoCompleted = String(autoComplete ?? '').toUpperCase() === AUTO_COMPLETE_STATUS.COMPLETED.toUpperCase()
  return (
    <Tooltip arrow disableInteractive title={isAutoCompleted ? T.AUTO_COMPLETED_VIA_GEOFENCE : T.MANUALLY_COMPLETED}>
      {isAutoCompleted ? (
        <PinDropOutlinedIcon fontSize="small" sx={{ color: 'success.main' }} />
      ) : (
        <PanToolOutlinedIcon fontSize="small" sx={{ color: 'text.secondary' }} />
      )}
    </Tooltip>
  )
}

export default ContainerCompletionBadge
